import React from 'react';

import styles from './DefaultSwissCenterView.module.scss';

const DefaultSwissCenterView = () => {
  return (
    <div className={styles.default_swiss_center_view}>
      <p>
        Nuestros <strong>Swiss Medical Center</strong> cuentan con prestigiosos profesionales,
        cómodas instalaciones y la tecnología más avanzada para brindarle una excelente atención
        programada y/o de urgencia.
      </p>
      <ul>
        <li>
          <strong>Consulta con especialistas</strong>
        </li>
        <li>
          <strong>Diagnóstico por imágenes</strong>
        </li>
        <ul>
          <li>Tomografía Axial Computada</li>
          <li>Resonancia Magnética Nuclear</li>
          <li>Ecografía General de adultos y niños</li>
          <li>Ecografía Obstétrica</li>
          <li>Ecografía Doppler</li>
          <li>Doppler Obstétrico y Ginecológico</li>
          <li>Ecocardiografía de Adultos y niños</li>
          <li>Ecodoppler Cardíaco Color</li>
          <li>Ecografía Transrectal</li>
          <li>Ecografía Transvaginal</li>
        </ul>
        <li>
          <strong>Laboratorio de Análisis Clínicos (certificado por Normas ISO 9000)</strong>
        </li>
        <li>
          <strong>Odontología</strong>
        </li>
        <li>
          <strong>Chequeo Médico Ejecutivo WellTEST</strong>
        </li>
        <li>
          <strong>Oftalmología de Alta Complejidad</strong>
        </li>
        <ul>
          <li>Consulta, servicio de diagnóstico y cirugía</li>
          <li>Oftalmología General</li>
          <li>Trauma ocular</li>
          <li>Patología de la retina</li>
          <li>Glaucoma</li>
          <li>Cataratas</li>
          <li>Vicios de refracción</li>
          <li>Oftalmopediatría</li>
        </ul>
      </ul>
    </div>
  );
};

export default DefaultSwissCenterView;
